<template>
  <el-form
    :model="form"
    :rules="rules"
    ref="ruralFormDom"
    label-width="132px"
    label-position="left"
  >
    <el-form-item label="单位名称" prop="appliName">
      <el-input
        class="input form-item"
        :disabled="true"
        v-model="form.appliName"
        placeholder="请输入"
      ></el-input>
    </el-form-item>
    <el-form-item label="单位类型" prop="appliType">
      <el-select
        class="form-item"
        v-model="form.appliType"
        placeholder="请选择"
        @change="handleSelectAppliType"
      >
        <el-option value="1" label="个人"></el-option>
        <el-option value="2" label="单位"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="法人姓名" prop="legalPerson">
      <el-input
        class="form-item"
        v-model="form.legalPerson"
        placeholder="请输入"
      ></el-input>
    </el-form-item>
    <el-form-item label="证件类型" prop="identifyType">
      <el-select
        class="form-item"
        v-model="form.identifyType"
        placeholder="请选择"
      >
        <el-option
          v-show="Number(form.appliType) === 1"
          value="01"
          label="身份证"
        ></el-option>
        <el-option
          v-show="Number(form.appliType) === 1"
          value="03"
          label="护照"
        ></el-option>
        <el-option
          v-show="Number(form.appliType) === 2"
          value="70"
          label="营业执照信用代码"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="证件号码" prop="identifyNumber">
      <el-input
        class="form-item"
        v-model="form.identifyNumber"
        placeholder="请输入"
      ></el-input>
    </el-form-item>
    <el-form-item label="证件有效期" prop="validDate">
      <el-date-picker
        type="date"
        class="form-item"
        v-model="form.validDate"
        placeholder="年-月-日"
        value-format="yyyy-MM-dd"
        :disabled="longEffective"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <el-checkbox
        v-model="longEffective"
        @change="changeEfficient"
        style="font-weight: 400"
        >长期有效</el-checkbox
      >
    </el-form-item>
    <el-form-item label="联系人姓名" prop="linkerName">
      <el-input
        class="form-item"
        v-model="form.linkerName"
        placeholder="请输入"
      ></el-input>
    </el-form-item>
    <el-form-item label="联系人电话" prop="phoneNumber">
      <el-input
        class="form-item"
        v-model="form.phoneNumber"
        placeholder="请输入"
      ></el-input>
    </el-form-item>
    <el-form-item label="经营地址" prop="appliAddress">
      <el-input
        class="form-item"
        v-model="form.appliAddress"
        placeholder="请输入"
      ></el-input>
    </el-form-item>
    <el-form-item v-if="isPuDong" label="投保机构" prop="comCode">
      <el-select class="form-item" v-model="form.comCode" placeholder="请选择">
        <el-option
          value="31015900"
          label="太平洋安信农业保险股份有限公司上海浦东支公司"
          key="comCode1"
        ></el-option>
        <el-option
          value="31011900"
          label="太平洋安信农业保险股份有限公司上海南汇支公司"
          key="comCode2"
        ></el-option>
        <el-option
          value="31011500"
          label="太平洋安信农业保险股份有限公司上海临港新片区支公司"
          key="comCode3"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="收款人" prop="accountName">
      <el-input
        class="form-item"
        v-model="form.accountName"
        placeholder="请输入"
      ></el-input>
    </el-form-item>
    <el-form-item label="银行账号" prop="accountCode">
      <el-input
        class="form-item"
        v-model="form.accountCode"
        placeholder="请输入"
      ></el-input>
    </el-form-item>
    <el-form-item label="银行" prop="bankName">
      <el-select
        class="form-item"
        v-model="form.bankName"
        placeholder="请选择"
        v-selectLoadMore="loadMoreBank"
        @change="submitItemInfo($event, 'bankName')"
        @blur="onBlurWithBankName"
        clearable
        filterable
        remote
        :remote-method="searchBank"
      >
        <el-option
          v-for="bank in bankList"
          :key="bank.id"
          :value="bank.bankTypeName"
          :label="bank.bankTypeName"
        ></el-option>
      </el-select>
      <div style="font-weight: 400; color: #cccccc">
        请输入关键字进行搜索，不支持缩写、简称
      </div>
    </el-form-item>
    <el-form-item label="开户支行" prop="bankBranchName">
      <el-select
        class="form-item"
        v-model="form.bankBranchName"
        placeholder="请选择"
        v-selectLoadMore="loadMoreBranchBank"
        @change="submitItemInfo($event, 'bankBranchName')"
        @blur="onBlurWithBankBranchName"
        clearable
        filterable
        remote
        :remote-method="searchBranchBank"
      >
        <el-option
          v-for="bank in branchBankList"
          :key="bank.id"
          :value="bank.bankBranchTypeName"
          :label="bank.bankBranchTypeName"
        ></el-option>
      </el-select>
      <div style="font-weight: 400; color: #cccccc">
        请输入关键字进行搜索，不支持缩写、简称
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
import validateMixins from "@/views/ruralInsurance/infoWrite/Form/validateMixins.js";
import {
  getBankList,
  getBranchBankList,
  getInsureInfoByFarmId,
} from "@/api/request/snkd.produce";
import { getAllCompanyInfo } from "@/api/request/snkd.user";
import { getStorage } from "@/utils/storage";
import { formatDate } from "@/utils";
export default {
  mixins: [validateMixins],
  data() {
    return {
      isPuDong: false, // 是否是浦东新区的农场
      formInfoId: null, // 表单信息回显数据的id
      longEffective: false, // 是否长期有效
      farmId: null,
      companyId: null,
      form: {
        appliName: "",
        appliType: "",
        legalPerson: "",
        comCode: null,
        identifyType: "",
        identifyNumber: "",
        validDate: "",
        linkerName: "",
        phoneNumber: "",
        appliAddress: "",
        bankName: "",
        bankCode: "",
        bankBranchName: "",
        bankBranchCode: "",
        companyId: null,
        farmId: null,
        accountName: "",
        accountCode: null,
      },
      pickerOptions: {
        disabledDate(time) {
          // 转换成统一时间格式再比较
          const cur = formatDate(time, "yyyy-MM-dd");
          const now = formatDate(new Date(), "yyyy-MM-dd");
          return new Date(cur).getTime() < new Date(now).getTime();
        },
      },
      // ------- 大行的数据
      bankList: [], // 银行列表
      bankTotal: 0, // 银行总数
      bankKeyword: "",
      bankPageNo: 1,
      // -------- 支行的数据
      branchBankList: [], // 支行列表
      branchBankTotal: 0, // 支行总数
      branchBankKeyword: "",
      branchBankPageNo: 1,
    };
  },
  computed: {},
  async mounted() {
    this.processFormDef();
    this.companyInfo = getStorage("COMPANYINFO");
    this.farmInfo = getStorage("FARMINFO");
    if (this.farmInfo) {
      this.farmId = this.farmInfo.farmId;
      this.companyId = this.farmInfo.companyId;
      this.form.farmId = this.farmInfo.farmId;
      this.form.companyId = this.farmInfo.companyId;
    }
    //获取企业法人
    const companyInfo = await this.getCompanyInfoByUser();
    this.form.legalPerson = companyInfo.obj.coCompanyVO.legalPerson;
    this.getBankList();

    // 获取之前填写的表单信息，用于回显数据
    const info = await getInsureInfoByFarmId({
      companyId: this.companyId,
      farmId: this.farmId,
    });
    if (info.respCode == 0) {
      if (info.obj) {
        // this.form = Object.assign(this.form, info.obj);
        Object.keys(this.form).forEach((key) => {
          if (key === "validDate") {
            this.form.validDate =
              info.obj.validDate == "2099-01-01" ? "" : info.obj.validDate;
            this.longEffective =
              info.obj.validDate == "2099-01-01" ? true : false;
          } else {
            this.form[key] = info.obj[key];
          }
        });
        this.formInfoId = info.obj.id || null;
        // 拿到大行的信息，获取支行列表
        this.getBranchBankList();
        // 单位与证件绑定与否
        const binding = this.judgeBinding(
          info.obj.appliType,
          info.obj.identifyType
        );
        if (!binding) {
          this.form.identifyType = "";
          this.form.identifyNumber = "";
        }
      }
      this.form.appliName = this.farmInfo ? this.farmInfo.farmName : "";
      this.judgeFormItem();
    }
    if (this.farmInfo && this.farmInfo.countyId === "310115") {
      this.isPuDong = true;
    }
  },
  methods: {
    changeEfficient(val) {
      if (val) {
        this.form.validDate = "";
      }
    },
    judgeBinding(appliType, identifyType) {
      if (Number(appliType) === 1) {
        // 个人
        return ["01", "03"].includes(identifyType);
      }
      if (Number(appliType) === 2) {
        return identifyType === "70";
      }
    },
    handleSelectAppliType(val) {
      const binding = this.judgeBinding(val, this.form.identifyType);
      if (!binding) {
        this.form.identifyType = "";
        this.form.identifyNumber = "";
      }
    },
    getCompanyInfoByUser() {
      return getAllCompanyInfo({ companyId: this.companyId });
    },
    // 提交每一项
    submitItemInfo(val, propName) {
      if (propName === "bankName") {
        // 当前选的是银行时
        this.form.bankBranchName = "";
        this.form.bankBranchCode = "";
        const bank = this.bankList.find((item) => item.bankTypeName == val);
        this.form.bankCode = bank ? bank.bankTypeCode : "";
        this.branchBankPageNo = 1;
        this.branchBankKeyword = "";
        this.getBranchBankList();
      }
      if (propName === "bankBranchName") {
        // 当前选择是支行时
        const branchBank = this.branchBankList.find(
          (item) => item.bankBranchTypeName == val
        );
        this.form.bankBranchCode = branchBank
          ? branchBank.bankBranchTypeCode
          : "";
      }
      // 取消失焦提交
      // this.$refs.formDom.validateField(propName, (errorMsg) => {
      //   console.log(`${propName}校验结果：`, errorMsg);
      //   if (!errorMsg) {
      //     const info = { ...this.form, id: this.formInfoId };
      //     addInsureInfo(info).then((res) => {
      //       console.log(`提交表单信息结果：`, res);
      //     });
      //   }
      // });
    },
    // 处理表单默认值
    processFormDef() {
      if (!this.companyInfo || !this.farmInfo) {
        this.companyInfo = getStorage("COMPANYINFO");
        this.farmInfo = getStorage("FARMINFO");
      }

      if (this.farmInfo && this.farmInfo.countyName) {
        const { provinceName, cityName, countyName, farmAddress } =
          this.farmInfo;
        if (farmAddress) {
          this.form.appliAddress =
            provinceName + cityName + countyName + farmAddress;
        } else {
          this.form.appliAddress = provinceName + cityName + countyName;
        }
      }
      // 联系人电话
      this.form.phoneNumber = getStorage("PHONE") || "";
    },
    // 验证表单整体
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.ruralFormDom.validate((valid) => {
          resolve(valid);
        });
      });
    },
    // 搜索银行
    searchBank(keyword) {
      this.bankPageNo = 1;
      this.bankKeyword = keyword;
      this.getBankList();
    },
    // 搜索银行失焦时
    onBlurWithBankName() {
      setTimeout(() => {
        this.bankList = this.temp_bankList;
      }, 500);
    },
    // 加载更多银行数据
    loadMoreBank() {
      if (this.bankList.length < this.bankTotal) {
        this.bankPageNo = this.bankPageNo + 1;
        this.getBankList();
      }
    },
    // 获取银行列表
    async getBankList() {
      const ajaxJson = {
        keyword: this.bankKeyword,
        pageNo: this.bankPageNo,
        pageSize: 10,
      };
      const res = await getBankList(ajaxJson);
      if (res.respCode == 0) {
        if (this.bankPageNo == 1) {
          this.bankList = res.obj.list;
          if (!this.bankKeyword) {
            this.temp_bankList = this.bankList;
          }
        } else if (this.bankPageNo > 1) {
          this.bankList = this.bankList.concat(res.obj.list);
        }
        this.bankTotal = res.obj.totalCount;
      }
    },

    // 搜索支行
    searchBranchBank(keyword) {
      this.branchBankPageNo = 1;
      this.branchBankKeyword = keyword;
      this.getBranchBankList();
    },
    // 搜索支行失焦
    onBlurWithBankBranchName() {
      setTimeout(() => {
        this.branchBankList = this.temp_branchBankList;
      }, 500);
    },
    // 加载更多支行数据
    loadMoreBranchBank() {
      if (this.branchBankList.length < this.branchBankTotal) {
        this.branchBankPageNo = this.branchBankPageNo + 1;
        this.getBranchBankList();
      }
    },
    // 获取支行列表
    async getBranchBankList() {
      const ajaxJson = {
        bankTypeCode: this.form.bankCode,
        keyword: this.branchBankKeyword,
        pageNo: this.branchBankPageNo,
        pageSize: 10,
      };

      const res = await getBranchBankList(ajaxJson);
      if (res.respCode == 0) {
        if (this.branchBankPageNo == 1) {
          this.branchBankList = res.obj.list;
          if (!this.branchBankKeyword) {
            this.temp_branchBankList = res.obj.list;
          }
        } else if (this.branchBankPageNo > 1) {
          this.branchBankList = this.branchBankList.concat(res.obj.list);
        }
        this.branchBankTotal = res.obj.totalCount;
      }
    },
    // 判断表单是否全都有初始信息
    judgeFormItem() {
      const formVals = Object.values(this.form);
      const someNoVal = formVals.some((val) => val == null || val === "");
      if (someNoVal) {
        this.$emit("openForm");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-item {
  width: 240px;
}
::v-deep .el-form-item.accountNameItem .el-form-item__label {
  line-height: 20px;
}
</style>
